module.exports = __webpack_public_path__ + "static/lunchtype22-regular-webfont-58f013d9075a96a27d127b31ea6d221c.woff";